import { makeStyles } from "@material-ui/core"

export default makeStyles(theme => ({
  img: {
    width: ({ width }) => width,
    minWidth: 28,
  },
}))
